import { Routes, Route, Navigate } from 'react-router-dom'

import DataManagmentRoutes from './DataManagment/DataManagment.routes'
import TemplateRoutes from './TemplateManagement/Template.routes'
import UserManagementRoutes from './UserManagment/UserManagment.routes'
import ErrorBoundaryComponent from '@/components/ErrorBoundaryComponent/ErrorBoundaryComponent'

export function SystemConfigureRoute() {
  return (
    <ErrorBoundaryComponent>
      <Routes>
        <Route
          path=""
          element={<Navigate to="user-management" replace={true} />}
        />
        <Route path="template/*" element={<TemplateRoutes />} />
        <Route path="data-management/*" element={<DataManagmentRoutes />} />
        <Route path="user-management/*" element={<UserManagementRoutes />} />
      </Routes>
    </ErrorBoundaryComponent>
  )
}
